export default __webpack_public_path__ + "static/media/translate.fb1e8357.svg";